export const SERVICES = [
  {
    id: "partes-blandas",
    num: "01",
    title: "Ecografías de Partes Blandas",
    short:
      "Evaluación de alta resolución de músculos, tendones, ligamentos, ganglios linfáticos y tejido subcutáneo.",
    image:
      "/assets/eco-partes-blandas.jpg",
    includes: [
      "Músculos, tendones y ligamentos",
      "Ganglios linfáticos y tejido subcutáneo",
      "Detección de masas, quistes y colecciones",
      "Informe diagnóstico el mismo día",
    ],
  },
  {
    id: "obstetricas",
    num: "02",
    title: "Ecografías Obstétricas",
    short:
      "Monitoreo integral del desarrollo fetal, bienestar materno-infantil e imágenes Doppler en tiempo real.",
    image:
      "/assets/eco-obstetrica.jpg",
    includes: [
      "Control del crecimiento y bienestar fetal",
      "Doppler obstétrico en tiempo real",
      "Perfil biofísico y líquido amniótico",
      "Imágenes para tu bebé en cada visita",
    ],
  },
  {
    id: "generales",
    num: "03",
    title: "Ecografías Generales",
    short:
      "Exploración completa abdominal, pélvica, renal, tiroidea y mamaria con equipamiento de última generación.",
    image:
      "/assets/eco-general.jpg",
    includes: [
      "Abdomen completo y pélvica",
      "Renal, vesical y prostática",
      "Tiroides y partes blandas del cuello",
      "Mamaria con correlación clínica",
    ],
  },
  {
    id: "morfologicas",
    num: "04",
    title: "Ecografías Morfológicas",
    short:
      "Examen detallado de la anatomía fetal entre las semanas 18 y 24 para la detección temprana de anomalías estructurales.",
    image:
      "/assets/eco-morfologica.jpg",
    includes: [
      "Anatomía fetal completa (semanas 18–24)",
      "Evaluación de corazón, cerebro y columna",
      "Medición de estructuras craneales y faciales",
      "Detección temprana de anomalías",
    ],
  },
  {
    id: "geneticas",
    num: "05",
    title: "Ecografías Genéticas",
    short:
      "Cribado especializado del primer trimestre (semanas 11–14) para evaluación de marcadores cromosómicos y translucidez nucal.",
    image:
      "/assets/eco-genetica.jpg",
    includes: [
      "Translucidez nucal (semanas 11–14)",
      "Marcadores de cromosomopatías",
      "Hueso nasal y ductus venoso",
      "Asesoría de resultados con especialista",
    ],
  },
  {
    id: "laboratorio",
    num: "06",
    title: "Exámenes de Laboratorio Clínico",
    short:
      "Análisis de sangre, orina, perfil lipídico, hormonal, microbiología y pruebas especializadas con entrega rápida de resultados.",
    image:
      "https://images.unsplash.com/photo-1639772823849-6efbd173043c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxtZWRpY2FsJTIwbGFib3JhdG9yeSUyMGJsb29kJTIwdGVzdCUyMHNjaWVudGlzdCUyMG1pY3Jvc2NvcGV8ZW58MHx8fHwxNzg5MDkzMTc4fDA&ixlib=rb-4.1.0&q=85",
    includes: [
      "Hemograma completo y glucosa",
      "Perfil lipídico, hepático y tiroideo",
      "Exámenes hormonales y microbiología",
      "Resultados rápidos y confiables",
    ],
  },
  {
    id: "cura-heridas",
    num: "07",
    title: "Cura de Heridas",
    short:
      "Limpieza, desinfección y vendaje profesional de heridas superficiales y postoperatorias para una cicatrización segura.",
    image: "/assets/cura-heridas.jpg",
    includes: [
      "Limpieza y desinfección de la herida",
      "Cambio de vendajes y apósitos",
      "Curaciones postoperatorias",
      "Control del proceso de cicatrización",
    ],
  },
  {
    id: "suturas",
    num: "08",
    title: "Suturas",
    short:
      "Cierre de heridas con técnica estéril y anestesia local, con retiro de puntos y seguimiento de la cicatrización.",
    image: "/assets/suturas.jpg",
    includes: [
      "Sutura de heridas y cortes",
      "Anestesia local incluida",
      "Retiro de puntos",
      "Seguimiento de la cicatrización",
    ],
  },
  {
    id: "lavado-oidos",
    num: "09",
    title: "Lavado de Oídos",
    short:
      "Irrigación segura del conducto auditivo para retirar tapones de cerumen y aliviar la sensación de oído tapado.",
    image: "/assets/lavado-oidos.jpg",
    includes: [
      "Evaluación previa del oído",
      "Irrigación segura e indolora",
      "Retiro de tapón de cerumen",
      "Recomendaciones de cuidado auditivo",
    ],
  },
  {
    id: "inyectables",
    num: "10",
    title: "Administración de Vitaminas e Inyectables (IM/EV)",
    short:
      "Aplicación de vitaminas, sueros y medicamentos por vía intramuscular o endovenosa, con personal capacitado y material estéril.",
    image: "/assets/inyectables.jpg",
    includes: [
      "Vitaminas y complejo B",
      "Inyectables intramusculares (IM)",
      "Aplicaciones endovenosas (EV) y sueros",
      "Registro y control de cada aplicación",
    ],
  },
  {
    id: "cauterizacion",
    num: "11",
    title: "Cauterización de Verrugas",
    short:
      "Eliminación de verrugas genitales y de otras partes del cuerpo mediante cauterización, con técnica segura y cuidado de la piel.",
    image: "/assets/cauterizacion.jpg",
    includes: [
      "Verrugas genitales y corporales",
      "Evaluación médica previa",
      "Procedimiento con cauterio",
      "Indicaciones para el cuidado posterior",
    ],
  },
];

export const CLINIC = {
  name: "ECOCORE DX",
  tagline: "Ecografía y Diagnóstico",
  phone: "982406090",
  phoneIntl: "+51982406090",
  whatsapp: "https://wa.me/51982406090",
  facebook: "https://www.facebook.com/share/1LbtNY5Q16/?mibextid=wwXIfr",
  instagram: "https://www.instagram.com/consultoriomedicoecocore",
  tiktok: "https://www.tiktok.com/@ecocoredx",
  address: "Av. Pacasmayo Mz F Lt 9, Urb. Las Praderas del Sol, 4ta Etapa",
  hours: "Lunes a Sábado · 8:00 AM – 7:00 PM",
  hoursSunday: "Domingos · Cita previa",
};
